		console.debug("Cookie Prüfung.", document.cookie);
		// Auf die IndexSeite wechseln, wenn das LoginCookie durch Logout gelöscht wurde.
		if (document.cookie.indexOf("reqCookie=") < 0) {
			console.debug("Cookie nicht gefunden! gehe auf login Seite ", document.cookie);
			location.replace(location.origin + '/fon/');
		}
		// Firefox und IE führen das obere JS nicht aus, wenn die Seite aus dem BF-Cache kommt.
		// In diesem Fall wird die Prüfung beim onpageshow Event ausgeführt.
		window.onpageshow = function() {
			if (document.cookie.indexOf("reqCookie=") < 0) {
				console.debug("Cookie nicht gefunden! gehe auf login Seite ", document.cookie);
				location.replace(location.origin + '/fon/');
			}
		};